//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { setTimeout } from "timers";
export default {
    name: "alliance_result",
    data() {
        return {
            title: "查询结果",
            record_type: "", //查询结果类型
            record_info:{}, //查询结果
            security_code: this.$route.query.security_code, //防伪码
            status: false, //判断状态 是否查询次数达到上线
            url: window.location.href, //当前地址
            securityCode: "",
            back: this.$route.query.back
        };
    },
    created() {
        if (sessionStorage.getItem("token") == null) {
            this.get_token(this.url);
        } else {
             this.get_inquire();
        }
    },
    methods: {
        get_token(url) {
            var self = this;
            this.$EpetJs.Common.approve(url,function() {
                    self.get_inquire();
                }
            ); //获取token
        },
        //获取查询信息
        get_inquire(){
            var self = this;
            this.securityCode = this.security_code.toUpperCase().replace(/(.{4})/g, "$1 ");
            var inquireResult=JSON.parse(sessionStorage.getItem('inquireResult'));
            if(inquireResult){
                if(inquireResult.status_code==200){
                    self.record_type=inquireResult.data.business_data.record_type;
                    if(self.record_type!=2){
                        self.record_info=inquireResult.data.business_data.record_info;
                    }
                }else if ((inquireResult.status_code = "403150001")){
                    self.status = true;
                }else if (inquireResult.status_code = "4051501002"){
                    self.$vux.toast.text(inquireResult.message);
                }else{
                    self.$vux.toast.text(inquireResult.message);
                }
            }
        },
        go_feedback() {
            this.$router.push({
                name: "alliance_feedback",
                query: {security_code: this.security_code }
            });
        }
    }
};
